import { Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";

const LinkPage = ({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}) => {
  return (
    <Link to={to} className="block hover:text-n-secondary font-light mb-3">
      {children}
    </Link>
  );
};

interface FooterProps {
  variant?: "simple" | "detailed";
}

export default function Footer({ variant = "detailed" }: FooterProps) {
  if (variant === "simple") {
    return (
      <footer className="bg-n-primary text-n-green-h-light pb-16 md:pb-0">
        <div className="mx-auto px-4 md:px-16 py-8">
          <div className="flex flex-col md:flex-row justify-between md:items-start items-center mb-8">
            <div className="mb-6 md:mb-0 text-start">
              <img
                src="/images/logo_md.png"
                alt="Nacional GO"
                className="h-8"
              />
            </div>

            {/* <div className="border border-n-beige rounded-lg max-w-sm text-n-beige">
              <h3 className="text-sm font-medium  border-b p-4 border-n-beige">
                Precisa de ajuda?
              </h3>
              <div className="grid grid-cols-2 text-sm ">
                <div className="text-center border-r  p-4 border-n-beige">
                  <p className="text-xs  mb-1">Telefone:</p>
                  <a
                    href="tel:08008780708"
                    className="underline hover:text-n-secondary transition-colors"
                  >
                    0800 878 0708
                  </a>
                </div>
                <div className=" py-4 px-1 md:p-4 text-center">
                  <p className="text-xs  mb-1">Email:</p>
                  <a
                    href="mailto:contato@nacionalgo.com.br"
                    className="underline text-xs hover:text-n-secondary transition-colors"
                  >
                    contato@nacionalgo.com.br
                  </a>
                </div>
              </div>
            </div> */}
          </div>

          {/* Legal links */}
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-n-green-4 mb-6 py-5 border-y border-n-green-7">
            <Link to="/termos" className="hover:text-n-secondary">
              Termos de Uso - Usuário
            </Link>

            <Link to="/privacidade" className="hover:text-n-secondary">
              Política de privacidade
            </Link>
          </div>

          {/* Copyright and cookies */}
          <div className="flex flex-col md:flex-row justify-between items-center text-xs text-n-green-4 ">
            <p>
              © Nacional GO 2025. Todos os direitos reservados. CNPJ
              46.951.207/0001-42
            </p>
            <Link to="/cookies" className="hover:text-n-secondary mt-2 md:mt-0">
              Configurações de Cookies
            </Link>
          </div>
        </div>
      </footer>
    );
  }

  // Detailed variant (your current footer with some adjustments)
  return (
    <footer className="bg-n-primary text-n-beige pb-16 md:pb-0">
      <div className="mx-auto px-4 md:px-16 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 text-sm">
          {/* Company info */}
          <div className="lg:col-span-1">
            <img
              src="/images/logo_md.png"
              alt="Nacional GO"
              className="mb-6 h-8"
            />

            <div className="mb-6">
              <p className="font-semibold mb-2">Endereço:</p>
              <p className="text-xs leading-relaxed">
                Rodovia José Carlos Daux, 4150
                <br />
                Primavera Office, Sala 102
                <br />
                Saco Grande, Florianópolis/SC
                <br />
                CEP 88.032-005
              </p>
            </div>

            {/* <div className="mb-6">
              <p className="font-semibold mb-2">Contato:</p>
              <a
                href="tel:08008780708"
                className="underline text-sm hover:text-n-secondary transition-colors block"
              >
                0800 878 0708
              </a>
              <a
                href="mailto:contato@nacionalgo.com.br"
                className="underline text-xs hover:text-n-secondary transition-colors block"
              >
                contato@nacionalgo.com.br
              </a>
            </div> */}

            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/nacionalgo/"
                className="hover:text-n-secondary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/nacional-go/"
                className="hover:text-n-secondary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Unidades */}
          <div>
            <h3 className="font-semibold mb-4">Unidades:</h3>
            <div className="space-y-2 text-sm">
              <p>Salvador/BA</p>
              <p>Duque de Caxias/RJ</p>
              <p>São Bernardo do Campo/SP</p>
              <p>São José/SC</p>
            </div>
          </div>

          {/* Sobre */}
          <div>
            <h3 className="font-semibold mb-4">Sobre</h3>
            <div className="space-y-2">
              <LinkPage to="/sobre">Conheça a Nacional GO</LinkPage>
              <LinkPage to="/trabalhe-conosco">Trabalhe Conosco</LinkPage>
              <LinkPage to="/seja-parceiro">Seja um Parceiro</LinkPage>
            </div>
          </div>

          {/* Soluções */}
          <div>
            <h3 className="font-semibold mb-4">Soluções</h3>
            <div className="space-y-2">
              <LinkPage to="/pra-voce">Para você</LinkPage>
              <LinkPage to="/para-sua-empresa">Para empresas</LinkPage>
            </div>
          </div>

          {/* Outros */}
          <div>
            <h3 className="font-semibold mb-4">Outros:</h3>
            <div className="space-y-2">
              <LinkPage to="/cadastro">Criar conta</LinkPage>
              <LinkPage to="/login">Login</LinkPage>
              <LinkPage to="/blog">Blog</LinkPage>
              <LinkPage to="/central-ajuda">Central de ajuda</LinkPage>
            </div>
          </div>
        </div>

        {/* Legal links */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-n-green-4 mt-12 mb-6 py-5 duration-300 border-y border-n-green-7">
          <Link to="/termos" className="hover:text-n-secondary">
            Termos de Uso - Usuário
          </Link>
          <Link to="/privacidade" className="hover:text-n-secondary">
            Política de privacidade
          </Link>
        </div>

        {/* Copyright and cookies */}
        <div className="flex flex-col md:flex-row justify-between items-center text-xs text-n-green-4 ">
          <p>
            © Nacional GO 2025. Todos os direitos reservados. CNPJ
            46.951.207/0001-42
          </p>
          <Link to="/cookies" className="hover:text-n-secondary mt-2 md:mt-0">
            Configurações de Cookies
          </Link>
        </div>
      </div>
    </footer>
  );
}
